module.exports = __webpack_public_path__ + "static/img/graymore_pictgrid13_980x845.1961fe8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/graymore_pictgrid13_980x845.jpg
// module id = PQDc
// module chunks = 0